<template>

    <div>
        <div class="save_ref_btn_container">
            <a class="button is-info is-rounded is-outlined" :disabled="!isRefValid" @click="updateRef">{{ $t('modules.refs.topbar.saveButton') }}</a>
        </div>

        <transition name="notif-slide-up">
            <alert v-if="refSaveNotif" context="success" @close="refSaveNotif=false">{{ $t('modules.refs.topbar.saveAlertSuccess') }}</alert>
        </transition>
    </div>

</template>

<script>
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'TopbarSaveBtn',
    components: {},
    data(){
        return {
            refSaveNotif: false
        }
    },
    computed: {
        currentRef(){
            return this.$store.state.RefStore.currentRef
        },
        formValidity(){
            return this.$store.state.RefStore.formValidity
        },
        isRefValid(){
            return (this.formValidity[0] && this.formValidity[1] && this.formValidity[2] && this.formValidity[3])
        }
    },
    methods:{
        updateRef(){
            if( userCanAccess('features', 'create_sight_ref') ){
                if(this.isRefValid){
                    this.$store.dispatch('RefStore/saveRef', this.currentRef).then(resp => {
                        this.refSaveNotif = true
                    }).catch(err => {
                        console.log('save_error')
                    })
                }
            }else{
                this.$router.push('/unautorized'); 
            }
        }
    }
}
</script>

<style lang="scss">
    .save_ref_btn_container{
        max-width: 160px;
        min-width: 160px;
        display: flex;
        height: 60px;
        justify-content: center;
        align-items: center;
    }
</style>